var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconShieldCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.256.128a2.16 2.16 0 0 1 1.306-.05l.182.06 6.375 2.273c.773.273 1.306.952 1.374 1.723l.007.166v4.748c0 4.89-3.326 9.467-7.894 10.861a2.06 2.06 0 0 1-1.212 0c-4.47-1.364-7.749-5.783-7.89-10.543L1.5 9.048V4.3c0-.792.481-1.496 1.22-1.833l.161-.066zm.73 2.094L3.766 4.42v4.627c0 3.85 2.592 7.484 6.076 8.68l.158.052.164-.053c3.39-1.165 5.933-4.634 6.064-8.375l.005-.304V4.429z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "m12.39 7.406-3.217 3.216L7.61 9.06a.943.943 0 0 0-1.334 1.334l2.23 2.23a.943.943 0 0 0 1.334 0l3.884-3.883a.943.943 0 1 0-1.334-1.334z"
}))));
export default SvgIconShieldCheck;